import { Theme } from '@mui/system';
import SxStyles from 'types/SxStyles.type';
import {
    containerFluid,
    drawerMiniWidth,
    drawerWidth,
    transition,
} from '../../materialUI/jss/material-dashboard-pro-react';

const appStyle: SxStyles = {
  headerDiv: {
    width: '100%',
    paddingTop: '400px',
    marginTop: '10px',
    background: '#ECEDEE',
  },
  wrapper: {
    position: 'relative',
    top: '0',
    height: 'var(--app-vh)',
    '&:after': {
      display: 'table',
      clear: 'both',
      content: '" "',
    },
  },
  mainPanel: (theme: Theme) => ({
    transitionProperty: 'top, bottom, width',
    transitionDuration: '.2s, .2s, .35s',
    transitionTimingFunction: 'linear, linear, ease',
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    overflowY: 'auto',
    overflowX: 'hidden',
    position: 'relative',
    float: 'right',
    ...transition,
    height: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    width: '100%',
    overflowScrolling: 'touch',
  }),
  content: {
    marginTop: '30px',
    padding: '30px 15px',
    minHeight: 'calc(var(--app-vh) - 123px)',
  },
  container: { ...containerFluid },
  map: {
    marginTop: '70px',
  },
  mainPanelSidebarMini: (theme: Theme) => ({
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerMiniWidth}px)`,
    },
  }),
  mainPanelWithPerfectScrollbar: {
    overflow: 'hidden !important',
  },
}

export default appStyle
